module.exports = __webpack_public_path__ + "static/img/setting.13c087d8.svg";